function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.527 6.584L.693 1.361 1.14.693 10.599 7l-9.46 6.307-.446-.668 7.834-5.223L9.151 7l-.624-.416z",
  fill: "#0D5A91",
  stroke: "#939598"
});

var SvgBespokenGreaterThanDisabled = function SvgBespokenGreaterThanDisabled(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgBespokenGreaterThanDisabled;